import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';

const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;
    const theme = useTheme();
    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={20} textAnchor="end" fill={theme.palette.text.primary} transform="rotate(-35)">
                {payload.value}
            </text>
        </g>
    );
};


function PropertyRoomNightSalesYearly({ data, colors }) {
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Box backgroundColor={colors.primary[400]} p="20px">
            <Typography variant="h5">
                PROPERTY ROOM NIGHT SALES
            </Typography>
            <Typography variant="h4" fontWeight="600" textTransform={"uppercase"}>
                WITH PREVIOUS YEARS
            </Typography>
            {data?.length ? (
                <Box
                    width={"100%"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mt={1}
                >
                    <ResponsiveContainer width={smScreen ? "100%" : "100%"} height={400}>
                        <BarChart
                            data={data}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 70,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" stroke={"#000000"} />
                            <XAxis dataKey="year" interval={0} height={60} tick={<CustomizedAxisTick/>}/>
                            <YAxis />
                            <Tooltip />
                            <Legend verticalAlign="top" wrapperStyle={{ paddingBottom: '20px' }}/>
                            <Bar dataKey="count" name="Total room nights" fill="#82ca9d">
                                <LabelList dataKey="count" position="top" style={{ fill: 'white' }} />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </Box>
            ) : (
                <Typography mt={15} mb={15} textAlign="center">
                    No Data Available...
                </Typography>
            )}
        </Box>
    )
}

export default PropertyRoomNightSalesYearly;